import { createSlice } from '@reduxjs/toolkit';
import type { NormalizedError } from 'errors/types';

export type SubmitEmailState = {
  isLoading: boolean;
  errors: null | NormalizedError[];
};

export const initialState: SubmitEmailState = {
  isLoading: false,
  errors: null
};

export const slice = createSlice({
  name: 'submitEmail',
  initialState,
  reducers: {
    setIsLoading: (state) => {
      state.isLoading = true;
      state.errors = initialState.errors;
    },
    setSuccess: (state) => {
      // You can handle the payload here if needed, for now just reset errors and loading
      state.isLoading = false;
      state.errors = initialState.errors;
    },
    setError: (state, { payload }) => {
      state.isLoading = false;
      state.errors = payload;
    }
  }
});

export const { setSuccess, setError, setIsLoading } = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectIsLoading = (state) => selectSlice(state).isLoading;
export const selectErrors = (state) => selectSlice(state).errors;

export default slice.reducer;
